<template>
  <div class="home">
    <p class="title">即将发售 敬请期待</p>
    <img class="middleimg" src="@/assets/drug.png" alt="" />
    <p class="subtitle">下载药联健康APP 新人享<span>280</span>健康好礼</p>

    <div class="download">
      <div
        class="downloadimg"
        v-clipboard:copy="copyText"
        alt=""
        @click="gotodownload"
        v-if="(isIOS || isWX) && !canOpen"
      >
        立即下载 预约体验
      </div>

      <!-- 打开app -->
      <div class="download" v-if="(isIOS || isWX) && canOpen">
        <div
          class="downloadimg-bg"
          v-clipboard:copy="copyText"
          alt=""
          @click="gotodownload"
          v-if="(isIOS || isWX) && canOpen"
        >
          立即打开APP
        </div>
        <wx-open-launch-app
          id="launch-btn"
          appid="wx3bd1a20ffcb1db00"
          :extinfo="copyText"
          @launch="handleLaunchFn"
          @error="handleErrorFn"
          class="downloadOpenApp"
        >
          <script type="text/wxtag-template">
            <style>.btn {width: 100vw; height: 51px; text-align: center;}</style>
            <div class="btn"></div>
          </script>
        </wx-open-launch-app>
      </div>
    </div>

    <a
      v-if="!isIOS && !isWX"
      :href="androidUrl"
      download="药联健康"
      v-clipboard:copy="copyText"
    >
      <div>立即下载 预约体验</div>
    </a>

    <div class="browser" v-if="show">
      <img class="image1" src="@/assets/箭头.png" alt="" />
      <div class="text1">
        <span>请点击右上角</span>
        <div class="text2">
          选择<img class="image2" src="@/assets/地球.png" alt="" />在浏览器打开
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// import axios from 'axios'
export default {
  name: "Drug",
  components: {},
  data() {
    return {
      show: false,
      isIOS: true,
      isWX: false,
      canOpen: false,
      copyText: "",
      androidUrl: "",
      iosUrl: "https://itunes.apple.com/cn/app/id1500372554?mt=8",
    };
  },
  created: function () {
    //配置微信
    window.udwxconfig(() => {
      this.canOpen = true;
    });
    this.isIOS = this.getIsIosClient();
    this.isWX = this.getIsWxClient();
    let that = this;
    Vue.axios
      .post(window["domain"] + "/common/getDownLoadUrl")
      .then((response) => {
        if (response.data.data && response.data.data.url) {
          that.androidUrl = response.data.data.url;
          console.log(response.data.data.url);
        }
      });

    if (window["channel"]) {
      this.copyText = `###***title=药联健康&channel=${window["channel"]}***###`;
    }
  },
  methods: {
    handleLaunchFn() {},
    handleErrorFn() {
      this.canOpen = false;
      this.gotodownload();
    },
    gotodownload() {
      if (!this.isIOS) {
        this.show = true;
      } else {
        window.open(this.iosUrl);
      }
    },
    getIsWxClient() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      }
      return false;
    },
    getIsIosClient() {
      var u = navigator.userAgent;
      // console.log('来了',u)
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        // console.log('安卓')
        return false;
      }
      if (isiOS) {
        // console.log('ios')
        return true;
      }
    },
  },
};
</script>

<style scoped>
.home {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #00b095;
}

.topimg {
  margin-top: 0.25rem;
  margin-left: 0.15rem;
  width: 1.56rem;
  height: 0.21rem;
}

p {
  text-align: center;
}

.title {
  font-size: 0.16rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  line-height: 0.32rem;
  text-align: center;
  margin: 0.09rem 0 0 0;
}

.subtitle {
  font-size: 0.16rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 0.21rem;
  margin: 0.28rem 0 0 0;
}

span {
  font-size: 0.16rem;
  color: #ffd685;
  font-weight: bold;
}

.middleimg {
  width: 3.12rem;
  /* height: 4.16rem; */
  margin-left: 0.36rem;
  margin-top: 0.1rem;
}

.download {
  position: fixed;
  bottom: 0.26rem;
  left: 0.16rem;
  right: 0.16rem;
  height: 0.45rem;
  /* width: 3.04rem; */

  font-weight: bold;
  background-color: #ffb635;
  color: #ffffff;
  font-size: 0.16rem;
  line-height: 0.45rem;
  border-radius: 0.225rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.downloadimg {
  height: 0.45rem;
  /* background-color: #000000; */
  /* width: 3.04rem; */
}

.downloadOpenApp {
  height: 0.45rem;
  width: 100%;
  z-index: 1000000000;
}
.downloadimg-bg {
  height: 0.45rem;
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0;
  top: 0;
}

a {
  position: fixed;
  bottom: 0.26rem;
  left: 0.16rem;
  right: 0.16rem;
  height: 0.45rem;
  /* width: 3.04rem; */
  text-decoration: none;
  font-weight: bold;
  background-color: #ffb635;
  color: #ffffff;
  font-size: 0.16rem;
  line-height: 0.45rem;
  border-radius: 0.225rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.browser {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #000000;
  opacity: 0.7;
}

.browser .image1 {
  position: absolute;
  right: 0.32rem;
  top: 0.09rem;
  width: 0.64rem;
  height: 0.66rem;
}

.text1 {
  position: absolute;
  right: 0rem;
  left: 0rem;
  top: 0.63rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  font-size: 0.18rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.25rem;
}
.text2 {
  margin-top: 0.07rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.browser .image2 {
  width: 0.18rem;
  height: 0.18rem;
  margin-left: 0.03rem;
  margin-right: 0.03rem;
}
</style>